// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3mky1","info":"UpdateTermsInfo_info__B48n4"};